import { AfterViewInit, Component, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable, of } from 'rxjs';
import { AnalyticalMethodDetailsPopupComponent } from 'src/app/common-components/analytical-method-details-popup/analytical-method-details-popup.component';
import { AnalyticalMethodDialogComponent } from 'src/app/modals/analytical-method-dialog/analytical-method-dialog.component';
import { AnalyticalMethod } from 'src/app/models/analyticalMethod.model';
import { AuthService } from 'src/app/services';
import { AnalyticalMethodService } from 'src/app/services/analytical-method.service';
import { CommonService } from 'src/app/services/common.service';
import { GridViewService } from 'src/app/services/grid-view.service';
import { ToastService } from 'src/app/services/toast.service';
import { TranslateService } from 'src/app/services/translate.service';
import { RolePermissionObjects } from 'src/app/shared/constants/rolePermissionObjects.constants';
import { segsRouteConfig } from 'src/app/shared/constants/segsRouteConfig.constants';
import { DeleteDialog } from 'src/app/shared/delete-dialog/delete-dialog.component';
import { FlyoutContainerComponent } from 'src/app/shared/flyout/flyout-container/flyout-container.component';
import { IFormDialogData } from 'src/app/shared/form/form.component';
import nameOf from 'src/app/shared/form/nameOf.helper';
import { CoreGridComponent } from 'src/app/shared/grid/core-grid/core-grid.component';
import { GridSettingsService } from 'src/app/shared/grid/core-grid/grid-settings-flyout/grid-settings.service';

@Component({
  standalone: false,
  selector: 'app-analytical-method',
  templateUrl: './../../shared/grid/core-grid/core-grid.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./../../shared/grid/core-grid/core-grid.component.scss', './analytical-method.component.scss']
})
export class AnalyticalMethodComponent extends CoreGridComponent<AnalyticalMethod> implements OnInit, AfterViewInit {
  @ViewChild(FlyoutContainerComponent) flyout!: FlyoutContainerComponent;
  constructor(
    protected analyticalMethodService: AnalyticalMethodService,
    toastService: ToastService,
    commonService: CommonService,
    dialog: MatDialog,
    authService: AuthService,
    gridViewService: GridViewService,
    private translationService: TranslateService,
    gridSettingsService: GridSettingsService
  ) {
    super(toastService, dialog, commonService, authService, gridViewService, gridSettingsService);
    this.gridService = analyticalMethodService;
  }

  protected get objectId(): string {
    return RolePermissionObjects.AnalyticalMethod;
  }

  protected override get isGridViewEnabled(): boolean { return true; }

  get hasOrgFilter(): boolean {
    return true;
  }

  ngAfterViewInit(): void {
    super.ngAfterViewInit();
    this.loadHeaderData();
  }

  override initializeProperties(): void {
    this.addEntityTitle = 'Analytical Methods';
    this.searchPlaceholder = 'Search Analytical Methods';
  }

  override initializeColumns(): void {
    this.additionalActions = [];
    this.columnConfigs = [
      {
        name: nameOf<AnalyticalMethod>(x => x.methodName), displayName: 'Method Name',
        cssClass: () => 'left-aligned cursor-pointer',
        onClick: (row: AnalyticalMethod) => {
          this.openFlyoutInternal(AnalyticalMethodDetailsPopupComponent, row.id, '60vw', true);
        }
      },
      { name: nameOf<AnalyticalMethod>(x => x.description), displayName: 'Description' },
      { name: nameOf<AnalyticalMethod>(x => x.agency), displayName: 'Agency' },
      { name: nameOf<AnalyticalMethod>(x => x.instrumentation), displayName: 'Instrumentation' },
      { name: nameOf<AnalyticalMethod>(x => x.url), displayName: 'Link to PDF', cellTemplate: (row) => `<a class="link" href="${row.url}" target='_blank'>${this.translationService.getDynamicTranslation('Link')}</a>` },
      { name: 'action', displayName: 'Actions' }
    ];
  }

  override initializeTabs(): any[] {
    return segsRouteConfig;
  }

  override initializeOverviewConfigs(): void {
    this.overviewConfigs = [];
  }

  override getOverviewData(): Observable<void> {
    return of(undefined);
  }

  override openEntityDialog(id?: string): void {
    const AnalyticalMethodModel: IFormDialogData = {
      id: id
    }
    this.openDialog(AnalyticalMethodDialogComponent, AnalyticalMethodModel)
  }

  override openEntityDeleteDialog(entity: AnalyticalMethod): void {
    this.openDeleteDialog(DeleteDialog, entity, this.analyticalMethodService, this.translationService.getDynamicTranslation('Analytical Method'));
  }
}
